import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import DocumentTitleProvider from './components/DocumentTitleProvider';
import { ThemeProvider } from '@/components/theme-provider';
import { FirebaseProvider, useFirebase } from './context/FirebaseProvider'; // Import FirebaseProvider and useFirebase
import AppRoutes from './routes/index';
import { Toaster } from '@/components/ui/toaster';
import { PageTracker } from '@/components/analytics/usePageTracking';
import { loadGoogleMapsScript } from '@/utils/mapsScriptLoader'; // Import the loader

// New component to load the Google Maps script
const AppContent: React.FC = () => {
  useEffect(() => {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

    if (apiKey && typeof apiKey === 'string' && apiKey.trim() !== '') {
      loadGoogleMapsScript(apiKey)
        .catch(error => console.error("Failed to load Google Maps script from AppContent:", error));
    } else {
      console.warn("VITE_GOOGLE_MAPS_API_KEY is not defined in environment variables. Google Maps script will not be loaded.");
    }
    // Dependency array is empty as environment variables are typically build-time constants
    // or don't change during the app lifecycle in a way React needs to track for this effect.
  }, []);

  return (
    <Router>
      <DocumentTitleProvider>
        <PageTracker />
        <AppRoutes />
        <Toaster />
      </DocumentTitleProvider>
    </Router>
  );
};

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="ui-theme">
      <FirebaseProvider> {/* Replace DataProvider with FirebaseProvider */}
        <AppContent />
      </FirebaseProvider>
    </ThemeProvider>
  );
}

export default App;
